import React from 'react'

function Next() {
    return (
        <div>
        <svg width="48" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="29" cy="29" r="29" fill="#EE7F4C"/>
        <path d="M11.9853 28.2508C10.8807 28.259 9.99192 29.161 10.0001 30.2655C10.0082 31.3701 10.9102 32.2589 12.0147 32.2507L11.9853 28.2508ZM47.4824 31.4038C48.2577 30.617 48.2484 29.3507 47.4616 28.5754L34.6403 15.9416C33.8535 15.1663 32.5872 15.1756 31.812 15.9624C31.0367 16.7492 31.046 18.0155 31.8328 18.7907L43.2295 30.0208L31.9994 41.4175C31.2241 42.2043 31.2334 43.4706 32.0202 44.2459C32.807 45.0212 34.0733 45.0119 34.8486 44.2251L47.4824 31.4038ZM12.0147 32.2507L46.0726 32L46.0431 28.0001L11.9853 28.2508L12.0147 32.2507Z" fill="white"/>
        </svg>
        
        </div>
    )
}

export default Next
